import { TDeviceType } from '@cian/ui-kit';

import { getTermValue, TJsonQuery } from '../../../../../../packages/JsonQuery';
import { EIcon, IOffer } from '../../../../../common/repositories/dailyrent/entities/offer/Offer';
import { selectMlSearchSessionGuid } from '../../../../../common/selectors/analytics';
import { selectIsDesktopListingVisible } from '../../../../../common/selectors/desktopListing';
import { selectJsonQuery } from '../../../../../common/selectors/filters';
import { selectListingMlRanking } from '../../../../../common/selectors/listingOffers/selectListingMlRanking';
import { selectQueryStringWithQMark } from '../../../../../common/selectors/queryString';
import { TListingProduct, trackListingOpen } from '../../../../../common/tracking/trackListingShow';
import { IApplicationState } from '../../../../../common/types/redux';
import { getAnalyticsPageType } from '../../../../../common/utils/analytics';

/**
 * Событие выдачи по клику на пин (№3 «Поисковая выдача», reason pin_click): в products - все объявления пина
 * в порядке показа, позиция с 1 - как в превью и листалке. Одиночный пин - выдача из одного объявления.
 * pageType: мобвеб - Listing, десктоп - ListingHybrid при открытом боковом листинге, иначе Map.
 */
export function trackPinListingShow(offers: IOffer[], state: IApplicationState, deviceType: TDeviceType): void {
  const jsonQuery = selectJsonQuery(state);
  const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;
  const products = offers.map(
    (offer, index): TListingProduct => ({
      id: offer.realtyId,
      position: index + 1,
      offerType: 'offer',
      extra: {
        isPriceWithDiscount: offer.icon === EIcon.Discount,
      },
    }),
  );

  trackListingOpen(
    'pin_click',
    getAnalyticsPageType({ deviceType, isDesktopListingVisible: selectIsDesktopListingVisible(state) }),
    pageNumber,
    offers.length,
    products,
    jsonQuery,
    selectMlSearchSessionGuid(state),
    selectListingMlRanking(state),
    selectQueryStringWithQMark(state),
  );
}
